import { render, staticRenderFns } from "./SideNavbar.vue?vue&type=template&id=05f72fca&"
import script from "./SideNavbar.vue?vue&type=script&lang=js&"
export * from "./SideNavbar.vue?vue&type=script&lang=js&"
import style0 from "./SideNavbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports